// GlobalCallHandler.js
import React from "react";
import { useCall } from "../../../context/CallContext";
import VideoCallModal from "../Chat/VideoCallModal";
import IncomingVideoCallModal from "../Chat/IncomingVideoCallModal";
import CallDisplayModal from "../Chat/CallDisplayModal";

const GlobalCallHandler = () => {
  const {
    isCalling,
    isReceivingCall,
    isInCall,
    callRejected,
    callEnded,
    outgoingCallRequest,
    incomingCall,
    callType,
    endCall,
  } = useCall();

  console.log("2. GlobalCallHandler render state:", {
    isCalling,
    isReceivingCall,
    isInCall,
    callRejected,
    callEnded,
    incomingCall,
    callType,
  });

  // CORRECTED: Use a single return with prioritized conditions.
  // callRejected/callEnded take priority so the connected-call UI's
  // "Call rejected"/"Call ended" screens show even if the call never
  // made it past the ringing/dialing stage.
  if (isInCall || callRejected || callEnded) {
    // The modal's onClose prop now correctly calls endCall()
    return <CallDisplayModal open={true} onClose={endCall} />;
  }

  if (isReceivingCall && incomingCall) {
    // We pass the incomingCall object as a prop, but not the functions
    return <IncomingVideoCallModal caller={incomingCall} callType={callType} />;
  }

  if (isCalling && outgoingCallRequest) {
    // The onClose prop correctly calls endCall()
    return (
      <VideoCallModal
        open={true}
        onClose={endCall}
        contact={outgoingCallRequest.contact}
        callType={callType}
      />
    );
  }

  return null;
};

export default GlobalCallHandler;
